import { AppUtil } from 'kuaidong-lib'
import { IAcademyItem } from './model'

export async function getList(): Promise<IAcademyItem[]> {
  return AppUtil.httpGET('/university/colleges', {})
}

export async function addAcademy(name: string, id?: string): Promise<any> {
  return AppUtil.httpPOST('/university/colleges', {
    id,
    name,
  })
}

export async function deleteAcademy(id: string): Promise<any> {
  return AppUtil.httpDelete('/university/colleges', {
    id,
  })
}
